import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunkAPIType } from "../../../app/appTypes";
import { deleteWithAuth, getWithAuth, postWithAuth, putWithAuth } from "../../../http";
import { RolePermission } from "../../permissions/permissionsSlice";

export interface CompanyRole {
    id: string
    name: string
    description: string | null
    isDefault: boolean
    userCount: number
    permissions: RolePermission[]
}

export interface SaveCompanyRole {
    name: string
    description: string | null
    copyFromRoleId?: string | null
    permissions?: RolePermission[] | null
}

export const loadCompanyRoles = createAsyncThunk<CompanyRole[], void, AppThunkAPIType>(
    "companyRoles/load",
    async (_, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({ url: "api/company-roles" }))
        const { payload } = result
        if (getWithAuth.fulfilled.match(result)) {
            return payload as CompanyRole[]
        } else {
            return rejectWithValue(payload ?? { kind: "unknown" })
        }
    }
)

export const createCompanyRole = createAsyncThunk<CompanyRole, SaveCompanyRole, AppThunkAPIType>(
    "companyRoles/create",
    async (data, { dispatch, rejectWithValue }) => {
        const result = await dispatch(postWithAuth({ url: "api/company-roles", payload: data }))
        const { payload } = result
        if (postWithAuth.fulfilled.match(result)) {
            return payload as CompanyRole
        } else {
            return rejectWithValue(payload ?? { kind: "unknown" })
        }
    }
)

export const updateCompanyRole = createAsyncThunk<CompanyRole, { id: string, data: SaveCompanyRole }, AppThunkAPIType>(
    "companyRoles/update",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        const result = await dispatch(putWithAuth({ url: `api/company-roles/${id}`, payload: data }))
        const { payload } = result
        if (putWithAuth.fulfilled.match(result)) {
            return payload as CompanyRole
        } else {
            return rejectWithValue(payload ?? { kind: "unknown" })
        }
    }
)

export const deleteCompanyRole = createAsyncThunk<void, string, AppThunkAPIType>(
    "companyRoles/delete",
    async (id, { dispatch, rejectWithValue }) => {
        const result = await dispatch(deleteWithAuth({ url: `api/company-roles/${id}` }))
        if (deleteWithAuth.fulfilled.match(result)) {
            return
        } else {
            return rejectWithValue(result.payload ?? { kind: "unknown" })
        }
    }
)

export const setDefaultCompanyRole = createAsyncThunk<void, string, AppThunkAPIType>(
    "companyRoles/setDefault",
    async (id, { dispatch, rejectWithValue }) => {
        const result = await dispatch(putWithAuth({ url: `api/company-roles/${id}/default`, payload: {} }))
        if (putWithAuth.fulfilled.match(result)) {
            return
        } else {
            return rejectWithValue(result.payload ?? { kind: "unknown" })
        }
    }
)
